import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchoolService {

  cognitoUserPoolId = environment.cognitoUserPoolId;
  cognitoClientId = environment.cognitoClientId;


  config = {
    StartDay: 'Sunday'
  };

  /**Get the instance level setting*/
  getSettings(): Observable<any> {
    return of(this.config);
  }
  constructor() { }
}
